import { useContext, useEffect, useState } from 'react';

import FilterContext from '../context/FilterContext';

const ANIMATION_DURATION_MS = 250;
const MINIMUM_INTERACTION_MS = 1;

function useFilterBottomSheet() {
    const { isOpen } = useContext(FilterContext);
    const [isHide, setIsHide] = useState<boolean>(true);
    const [isNone, setIsNone] = useState<boolean>(true);
    useEffect(() => {
        if (isOpen) {
            setIsNone(false);
            const showTimeout = setTimeout(() => {
                setIsHide(false);
            }, MINIMUM_INTERACTION_MS);
            return () => clearTimeout(showTimeout);
        }
        setIsHide(true);
        const hideTimeout = setTimeout(() => {
            setIsNone(true);
        }, ANIMATION_DURATION_MS);
        return () => clearTimeout(hideTimeout);
    }, [isOpen]);

    return {
        isHide, isNone,
    };
}

export default useFilterBottomSheet;
